module.exports = __webpack_public_path__ + "img/puck-buddies-bg.a872bb34.png";